<template>
    <div>
        <div>
            <img class="top_img1" src="../../assets/img//zhuanlifuwu.jpg" />
        </div>
        <div class="list_main white_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle" style="color: #4d6fff">专利服务</h3>
                <div class="subTitle">资深专利专家与数十位硕博团队，为您提供专业的专利服务，涵盖专利申请、运用全流程，赋予您的科研成果权利、价值和荣誉。</div>
                <div class="cardList">
                    <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                        <el-col v-for="item in patentServeList" :key="item.index" :span="8" class="test_col ">
                            <div class="advantage_card boderCol">
                                <img style="width: 30%;" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                                <div class="testFlow_content">{{ item.content }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="list_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">优势特点</h3>
                <div class="cardList">
                    <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                        <el-col v-for="item in advantageList" :key="item.index" :span="6" class="test_col">
                            <div class="dvantage_next">
                            </div>
                            <div class="advantage_card">
                                <img class="dvantage_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="list_main e4_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">专利申请流程</h3>
                <div class="cardList">
                    <div class="patentServe">
                        <div v-for="item in applyseveList" :key="item.index" class="patent_col">
                            <div class="patent_card">
                                <img class="patent_img" :src="item.src" />
                                <div class="patent_name">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_main white_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle" style="color: #4d6fff">成果报奖</h3>
                <div class="subTitle">全球知名的科研平台，优秀专业的成果报奖团队为您提供PPT、视频、专利、项目书的策划、制作服务。将您的科研生动地呈现在专家评面前！</div>
                <div class="cardList">
                    <el-row :gutter="30" type="flex" style="flex-wrap: wrap;">
                        <el-col v-for="item in resultList" :key="item.index" :span="6" class="test_col ">
                            <div class="advantage_card boderCol" style="min-height: 170px">
                                <img style="width: 30%;" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                                <div class="testFlow_content">{{ item.content }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="list_main submitRequire">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">项目申报流程</h3>
                <div class="flowcardList">
                    <div class="testList">
                        <div v-for="item in proApplyFlowList" :key="item.index" class="test_col">
                            <div class="pro_flow_next">
                                <img src="../../assets/img/next.png" />
                            </div>
                            <div class="testFlow_card">
                                <img class="proFlow_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">服务流程</h3>
                <div class="cardList">
                    <el-row type="flex" class="serve_flow">
                        <el-col v-for="item in serveFlowList" :key="item.index" :span="4" class="serve_flow_col">
                            <div class="serve_flow_col_border"> </div>
                            <div class="serve_flow_card">
                                <img class="serve_flow_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="list_main white_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">PPT美化</h3>
                <div class="cardList">
                    <div class="member_img_list">
                        <div class="img_list_main">
                            <div>
                                <img src="../../assets/img/ppt1.jpeg"/>
                            </div>
                            深度优化（PPT封面）   100元/页起
                        </div>
                        <div class="img_list_main">
                            <div>
                                <img src="../../assets/img/ppt2.jpeg"/>
                            </div>
                            深度优化（PPT封面）   100元/页起
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_main submitRequire">
            <contentIndex :initInfo="info"></contentIndex>
        </div>
    </div>
</template>
<script>
import uploadText from "../common/uploadText"
import contentIndex from "./index.vue"

export default {
    components: {
        uploadText,
        contentIndex
    },
    data() {
        return {
            info: {
                type: 11,
                testTypeList: [],
            },
            patentServeList: [
                {
                    name: "专利检索与申请",
                    content: "帮您保护来之不易的科研成果",
                    src: require("../../assets/img/zljs.png")
                },
                {
                    name: "专利培育与挖掘",
                    content: "帮您寻找科研成果闪光点",
                    src: require("../../assets/img/zlpy.png")
                },
                {
                    name: "专利导航与分析",
                    content: "帮您寻找科研新路径",
                    src: require("../../assets/img/zldh.png")
                },
            ],
            proApplyFlowList: [
                {
                    name: "1.申报",
                    src: require("../../assets/img/xmsb.png")
                },
                {
                    name: "2.立项",
                    src: require("../../assets/img/xmlx.png")
                },
                {
                    name: "3.研究",
                    src: require("../../assets/img/xmyj.png")
                },
                {
                    name: "4.评估",
                    src: require("../../assets/img/xmsb.png")
                },
                {
                    name: "5.结题",
                    src: require("../../assets/img/xmjt.png")
                },
                {
                    name: "6.评奖",
                    src: require("../../assets/img/xmpj.png")
                },
                {
                    name: "7.公示",
                    src: require("../../assets/img/xmgs.png")
                },
            ],
            serveFlowList: [
                {
                    name: "1.添加微信",
                    src: require("../../assets/img/tjwx.png")
                },
                {
                    name: "2.提出要求",
                    src: require("../../assets/img/tcyq.png")
                },
                {
                    name: "3.报价",
                    src: require("../../assets/img/bj.png")
                },
                {
                    name: "4.确认合作",
                    src: require("../../assets/img/qrhz.png")
                },
                {
                    name: "5.开始运作",
                    src: require("../../assets/img/ksyz.png")
                },
                {
                    name: "6.结果交付",
                    src: require("../../assets/img/jgjf.png")
                }
            ],
            resultList: [
                {
                    name: "科技奖项",
                    content: "进步/发明/自然/杰出贡献",
                    src: require("../../assets/img/kyjx.png")
                },
                {
                    name: "基金人才",
                    content: "长江/中原/杰青/优青/百千万/院士",
                    src: require("../../assets/img/jjrc.png")
                },
                {
                    name: "科研平台",
                    content: "技术中心/研发机构/重点实验室/院士工作站",
                    src: require("../../assets/img/kypt.png")
                },
                {
                    name: "科研项目",
                    content: "科技攻关/重大专项/重点项目",
                    src: require("../../assets/img/kyxm.png")
                },
            ],
            applyseveList: [
                { name: "1.专业交底", src: require("../../assets/img/zyjd.png") },
                { name: "2.专利撰写", src: require("../../assets/img/zljx.png") },
                { name: "3.递交专利局", src: require("../../assets/img/djzlj.png") },
                { name: "4.初步审查", src: require("../../assets/img/cbsc.png") },
                { name: "5.实质审查", src: require("../../assets/img/szsc.png") },
                { name: "6.授权缴费", src: require("../../assets/img/sqjf.png") },
                { name: "7.获得证书", src: require("../../assets/img/hdzs.png") },
            ],
            advantageList: [
                {
                    name: "专业的博士团队",
                    src: require("../../assets/img/zybj.png")
                },
                {
                    name: "优选代理机构合作",
                    src: require("../../assets/img/fwqm.png")
                },
                {
                    name: "资深的业内专家",
                    src: require("../../assets/img/ynzj.png")
                },
                {
                    name: "订单直通车1V1服务",
                    src: require("../../assets/img/shws.png")
                }
            ],
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
.flowcardList {
    width: 70%;
    margin: 0 auto;
}

.advantage_card {
    text-align: center;
    padding: 30px;
}

.dvantage_img {
    width: 50%;
}

.dvantage_next {
    border-right: 2px solid #E4E7ED;
    height: 85%;
    position: absolute;
    right: 0;
    top: 5%;
}
.member_img_list {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    width: 100%;
}
.img_list_main {
    display: flex;
    flex-flow: column;
    text-align: center;
    width: 45%;
    img{
        width: 100%;
        border: 1px solid #999;
  }
}
.flow_next {
    img {
        width: 45%;
    }

    position: absolute;
    right: -60px;
    top: 33%;
}

.pro_flow_next {
    img {
        width: 30%;
    }

    position: absolute;
    right: -70px;
    top: 33%;
}

.test_col:last-child .pro_flow_next {
    display: none;
}

.proFlow_img {
    width: 70%;
}

.test_col:last-child .dvantage_next {
    display: none;
}

.testFlow_Name {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin: 10px;
}

.boderCol {
    border: 1px solid #EBEEF5;
    border-radius: 3px;
}

.patentServe {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
}

.patent_col {
    width: 13%;
}

.testList {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}

.testFlow_card {
    text-align: center;
    padding: 30px;
    // width: 210px;
}

.patent_img {
    width: 100%;
    display: block;
}

.patent_name {
    width: 100%;
    background: #4d6fff;
    height: 50px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.testFlow_img {
    width: 45%;
}

.testList {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}

.test_col {
    position: relative;
}
.testFlow_content {
    color: #999999;
    font-size: 13px;
    line-height: 25px;
}

.test_col:last-child .flow_next {
    display: none;
}
.serve_flow_col {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 225px;
    height: 225px;
    box-sizing: content-box;
    position: relative;
}

.serve_flow_col_border {
    width: 217px;
    height: 108px;
    border: 8px solid #4d6fff;
    position: absolute;
}

.serve_flow {
    width: 1400;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

}
.serve_flow_card {
    border-radius: 50%;
    background: #fff;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
}
@media only screen and (max-width: 1700px) {
    .serve_flow_col {
        width: 200px;
        height: 200px;
    }

    .serve_flow_col_border {
        width: 193px;
        height: 95px;
        border: 7px solid #4d6fff;
    }
    .serve_flow_card {
        width: 130px;
        height: 130px;
    }
    .serve_flow {
        width: 1400;
    }
}
@media only screen and (max-width: 1500px) {
    .serve_flow_col {
        width: 175px;
        height: 175px;
    }

    .serve_flow_col_border {
        width: 168px;
        height: 83px;
        border: 7px solid #4d6fff;
    }
    .serve_flow_card {
        width: 110px;
        height: 110px;
    }
    .testFlow_Name {
        font-size: 14px;
    }
    .serve_flow {
        width: 1400;
    }
}
@media only screen and (max-width: 1400px) {
    .serve_flow_col {
        width: 155px;
        height: 155px;
    }
    .serve_flow_card {
        width: 100px;
        height: 100px;
    }
    .serve_flow_col_border {
        width: 150px;
        height: 73px;
        border: 5px solid #4d6fff;
    }
    .testFlow_Name {
        font-size: 13px;
    }
    .serve_flow {
        width: 1300;
    }
    .serve_flow_card {
        width: 100px;
        height: 100px;
    }
}
@media only screen and (max-width: 1200px) {
    .serve_flow_col {
        width: 145px;
        height: 145px;
    }

    .serve_flow_col_border {
        width: 140px;
        height: 70px;
        border: 5px solid #4d6fff;
    }
    .testFlow_Name {
        font-size: 12px;
        line-height: 10px;
        font-weight: 500;
    }
    .serve_flow {
        width: 1200;
    }
    .serve_flow_card {
        width: 90px;
        height: 90px;
    }
}

.serve_flow_col:nth-child(even) .serve_flow_col_border {
    border-radius: 50% 50% 0 0/100% 100% 0 0;
    border-bottom: none;
    top: 0;
}

.serve_flow_col:nth-child(odd) .serve_flow_col_border {
    border-radius: 0 0 50% 50%/0 0 100% 100%;
    border-top: none;
    bottom: 0;
    opacity: 0.4;
}
.serve_flow_img {
    width: 30%;
    margin-top: 8px;
}</style>